import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import React from 'react'
import { rightImg, watchImg } from '../utils'
import VideoCarousel from './VideoCarousel'

const Highlights = () => {

  useGSAP(()=>{
    gsap.to('#title',{  y: 0,  opacity: 1, delay:0.25})
    gsap.to('.link',{ y: 0, opacity: 1,duration: 1, stagger:0.5})
  },[])
  return (
    <section id='highlights' className='w-screen overflow-hidden h-full common-padding bg-zinc' >

      <div className='screen-max-width'>

        <div className='mb-12 md:flex w-full items-end justify-between'>

          <h1 id='title' className='section-heading'>Get the highlights. </h1>
          <div className='flex flex-wrap items-end gap-5 '>
            <p className='link '>
              Watch the film
              <img src={watchImg} alt="watch" className='ml-2'/>
            </p>
            <p className='link '>
              Watch the events
              <img src={rightImg} alt="watch" className='ml-2'/>
            </p>
          </div>
        </div>
      </div>
      <VideoCarousel/>
    </section >
  )
}

export default Highlights